export default __webpack_public_path__ + "static/media/placeholder_male.bc11150f.jpg";